"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtendGuarantee = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _PopupArticle = require("../Article/PopupArticle");
var _Button = require("../Button");
var _Modal = require("../Modal/Modal");
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _sanitizeHtmlOptions = _interopRequireDefault(require("../../constants/sanitizeHtmlOptions"));
var _tools = require("../../utils/tools");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ExtendGuarantee = function ExtendGuarantee(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    showArticle = _useState4[0],
    setShowArticle = _useState4[1];
  var modal = props.modal,
    article = props.article;
  var closeModal = function closeModal() {
    return setActive(false);
  };
  (0, _react.useEffect)(function () {
    setActive(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    active: active,
    title: modal === null || modal === void 0 ? void 0 : modal.title,
    onClose: closeModal,
    footer: {
      layout: 'horizontal',
      buttons: [{
        text: modal === null || modal === void 0 ? void 0 : modal.refuse_value,
        style: {
          color: '#000'
        },
        onClick: closeModal
      }, {
        text: modal === null || modal === void 0 ? void 0 : modal.confirm_value,
        action: _objectSpread({
          showUserMessage: false,
          func: 'next'
        }, (modal === null || modal === void 0 ? void 0 : modal.confirmAction) || {}),
        onClick: closeModal
      }]
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: (0, _tools.formatHtml)((0, _sanitizeHtml.default)(modal === null || modal === void 0 ? void 0 : modal.content, _sanitizeHtmlOptions.default))
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    text: modal === null || modal === void 0 ? void 0 : modal.read_more,
    type: "frameless",
    onClick: function onClick() {
      return setShowArticle(true);
    },
    style: {
      display: 'inline-block',
      minWidth: 'unset',
      margin: 'unset',
      padding: 'unset',
      marginLeft: '0.5rem',
      color: '#0088FF'
    }
  })), /*#__PURE__*/_react.default.createElement(_PopupArticle.PopupArticle, {
    active: showArticle,
    title: article === null || article === void 0 ? void 0 : article.title,
    content: article === null || article === void 0 ? void 0 : article.content,
    onClose: function onClose() {
      return setShowArticle(false);
    }
  }));
};
exports.ExtendGuarantee = ExtendGuarantee;